export const securitySetup = {
  junior: {
    requirements: [
      { name: 'Data Privacy Training', description: 'Complete comprehensive data privacy and GDPR training', priority: 'high' },
      { name: 'Stakeholder Data Access', description: 'Secure access to stakeholder and customer data', priority: 'high' },
      { name: 'Agile Tool Security', description: 'Secure configuration of agile management tools', priority: 'medium' },
      { name: 'Communication Security', description: 'Secure communication practices with teams and stakeholders', priority: 'medium' }
    ],
    procedures: [
      { step: 'Complete privacy certification', command: 'Complete company data privacy and GDPR certification' },
      { step: 'Configure secure tool access', command: 'Set up secure access to JIRA, Confluence, and collaboration tools' },
      { step: 'Enable 2FA on all platforms', command: 'Enable two-factor authentication on all product management tools' },
      { step: 'Review data handling policies', command: 'Understand customer and stakeholder data handling procedures' }
    ]
  },
  mid: {
    requirements: [
      { name: 'Product Security Reviews', description: 'Participate in product security and privacy reviews', priority: 'high' },
      { name: 'Compliance Management', description: 'Ensure agile processes comply with security standards', priority: 'high' },
      { name: 'Vendor Security Assessment', description: 'Assess security of product management tools and vendors', priority: 'medium' },
      { name: 'Data Governance', description: 'Implement data governance in product development', priority: 'medium' }
    ],
    procedures: [
      { step: 'Conduct security assessments', command: 'Participate in regular product and process security reviews' },
      { step: 'Implement compliance checks', command: 'Set up compliance monitoring in agile workflows' },
      { step: 'Evaluate tool security', command: 'Assess security of product management and analytics tools' },
      { step: 'Document security requirements', command: 'Include security requirements in user stories and acceptance criteria' }
    ]
  },
  senior: {
    requirements: [
      { name: 'Security Strategy', description: 'Define security strategy for product ownership practices', priority: 'high' },
      { name: 'Privacy by Design', description: 'Implement privacy by design in product development', priority: 'high' },
      { name: 'Regulatory Compliance', description: 'Ensure compliance with industry regulations in product processes', priority: 'high' },
      { name: 'Security Culture', description: 'Foster security culture within product and agile teams', priority: 'medium' }
    ],
    procedures: [
      { step: 'Define security framework', command: 'Develop comprehensive security framework for product ownership' },
      { step: 'Implement privacy controls', command: 'Design privacy controls into product development processes' },
      { step: 'Establish compliance processes', command: 'Create compliance framework for agile product development' },
      { step: 'Security training program', command: 'Develop security awareness training for product teams' }
    ]
  }
};
